import React from 'react';
import "./Header.css";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import { Link } from "react-router-dom";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import "./style.css";
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";

function Header() {

    const [{ basket, user }, dispatch] = useStateValue();
    // const [{ basket }, dispatch] = useStateValue();

    const email = user?.email;
    const username = /[^@]*/.exec(email)[0];

    const handleAuthenticaton = () => {
        if (user) {
            auth.signOut();
        }
    }

    return (
        <nav className="header">
            <Link to="/">
                <MenuIcon className="header__menu" fontSize="large" />
                <img
                    className="header__logo"
                    src="https://fontmeme.com/permalink/201013/b233f858c50324a5e769f522ebbfd392.png"
                    alt=""
                />
            </Link>

            <div className="header__search">
                <input className="header__searchInput" type="text" />
                <SearchIcon className="header__searchIcon" />
            </div>

            <div className="header__nav">
                <Link to=
                    {!user && '/login'}
                    className="header__link"
                >
                    <div
                        onClick={handleAuthenticaton}
                        className="header__option">
                        <span className="header__optionLineOne">Hello, {' '}
                            {!user ? 'Guest' : username}
                        </span>
                        <span className="header__optionLineTwo">
                            {user ? 'Sign Out' : 'Sign In'}
                        </span>
                    </div>
                </Link>

                <Link to='/orders' className="header__link">
                    <div className="header__option">
                        <span className="header__optionLineOne">Returns</span>
                        <span className="header__optionLineTwo">& Orders</span>
                    </div>
                </Link>


                <div className="header__option">
                    <span className="header__optionLineOne">Armazon</span>
                    <span className="header__optionLineTwo">Prime</span>
                </div>

                <Link to="/checkout" className="header__link">
                    <div className="header__optionBasket">
                        <ShoppingBasketIcon />
                        <span className="header__optionLineTwo header__basketCount">
                            {basket?.length}
                        </span>
                    </div>
                </Link>
            </div>

        </nav>
    )
}

export default Header
